import { render } from "./Home.vue?vue&type=template&id=7a21f2bc"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script